// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"feedteststyle_headerColumn__Wne6a","rowColumn":"feedteststyle_rowColumn__2xRJV"};